import { useEffect, useState } from 'react';
import { errorRingBuffer } from '../utils/errorRingBuffer';

interface ErrorPresence {
  hasRecentError: boolean;
  lastErrorAt: string | null;
  errorCount: number;
}

const POLL_INTERVAL_MS = 5000;

export function useErrorPresence(): ErrorPresence {
  const [state, setState] = useState<ErrorPresence>(() => ({
    hasRecentError: errorRingBuffer.hasRecentError(),
    lastErrorAt: errorRingBuffer.lastErrorAt(),
    errorCount: errorRingBuffer.recentErrorCount(),
  }));

  useEffect(() => {
    function tick() {
      setState({
        hasRecentError: errorRingBuffer.hasRecentError(),
        lastErrorAt: errorRingBuffer.lastErrorAt(),
        errorCount: errorRingBuffer.recentErrorCount(),
      });
    }

    const id = setInterval(tick, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return state;
}
